import ArrowUpRight16 from '@carbon/icons-react/es/arrow--up-right/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import { Layout, Skeleton } from 'antd';
import React, { FC, useState } from 'react';
import { ProjectId } from 'api/models';
import { useActiveGlobalConversation } from '../../proj-conversation-hooks';
import { useOpenConversationItem } from '../channel-details';
import { ConversationIcon } from '../conv-item';
import { UpdateConversationModal } from '../conversation-form';
import { ProjectGlobalConversationPane } from './global-conversation-pane';
import {
  ChannelName,
  Content,
  ConversationHeader,
  HeaderContent,
  HeaderContentPart,
} from './styles';

interface Props {
  projectId: ProjectId;
}

export const ProjectGlobalConversationPaneWrapper: FC<Props> = ({
  projectId,
}) => {
  const { activeConversation, loading } = useActiveGlobalConversation();
  const [isUpdateDetailsModalVisible, setUpdateConversationModalVisibility] =
    useState(false);
  const onOpen = useOpenConversationItem(projectId, activeConversation);

  if (loading || !activeConversation) {
    return <Skeleton title={false} />;
  }

  return (
    <Layout.Content>
      <Content>
        <HeaderContent private={activeConversation.private}>
          <ConversationHeader
            private={activeConversation.private}
            onClick={onOpen}
            data-cy="conversation-header"
          >
            <ConversationIcon
              conversation={activeConversation}
              staticIcon={false}
            />
            <ChannelName>{activeConversation?.entityName}</ChannelName>
            {activeConversation.displayEntityType === 'tasks' ? (
              <ChevronRight16 />
            ) : (
              <ArrowUpRight16 />
            )}
          </ConversationHeader>
          <HeaderContentPart>
            <UpdateConversationModal
              isVisible={isUpdateDetailsModalVisible}
              onCancel={() => setUpdateConversationModalVisibility(false)}
            />
          </HeaderContentPart>
        </HeaderContent>
        <ProjectGlobalConversationPane
          projectId={projectId}
          isUserMemberOfChannel
        />
      </Content>
    </Layout.Content>
  );
};
